import React, { useCallback, useState } from "react";
import { Box, Grid, Button, Dialog, Grid2 } from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
// import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  deleteEmployee,
  getManager,
  updateEmployee,
} from "../../services/user.service";
import AddUser from "../User/AddUser";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { ToastError, ToastSuccess } from "../../utils/Toaster/Toaster";
import MasterCommonTable from "../../sharedComponents/MaterCommonTable/MasterCommonTable";
import { useNavigate } from "react-router-dom";
import { debounce } from "../../utils/debounce";
import { encryptData } from "../../utils/cryptoUtils";
import PermissionGate from "../../components/Permission/PermissionGate";
import { usePermissions } from "../../context/PermissionProvider";

const Manager = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openManagerDrawer, setOpenManagerDrawer] = useState(false);
  const { canAdd, canEdit, canDelete } = usePermissions();
  const [selectedData, setSelectedData] = useState({});
  const [tableTotalCount, setTableTotalCount] = useState(0);
  const [data, setData] = useState([]);
  const [queryParam, setQueryParam] = useState({
    search: "",
    page: 1,
    limit: 10,
  });

  const navigate = useNavigate();

  const getData = async () => {
    try {
      const payload = {
        search: encryptData(queryParam.search || ""),
        page: encryptData(queryParam.page || 1),
        limit: encryptData(queryParam.limit || 10),
      };
      console.log("Encrypted Payload:", payload);
      const res = await getManager(payload);
      const modifiedData =
        res?.data.data.map((e) => ({
          ...e,
        })) || [];
      setData(modifiedData);
      console.log("RES",modifiedData);
      setTableTotalCount(res?.data?.totalCount || 0);
    } catch (error) {
      ToastError(error.data.message);
      console.log(error, "DATAERROR");
    }
  };

  React.useEffect(() => {
    getData();
  }, [queryParam.search, queryParam.page, queryParam.limit, queryParam.sort]);

  const handleAdd = () => {
    setOpenDrawer(true);
    setSelectedData({});
  };

  const handleView = (e) => {
    e.isView = true;
    navigate(`/home/employeeDetails?id=${e._id}`);
    setSelectedData(e);
  };

  const handleEdit = (e) => {
    e.isView = false;
    setSelectedData(e);
    navigate("/home/editManager", {
      state: { selectedData: e, formType: "edit" },
    });
  };

  const handleDelete = async (e) => {
    try {
      const res = await deleteEmployee(e._id);
      ToastError(res.message);
      getData();
    } catch (error) {
      console.log(error);
    }
  };
  const handleToggle = async (e) => {
    console.log(e, "EEEEEE");
    try {
      const formData = new FormData();
      const payload = {
        isEnabled: !e.isEnabled,
      };
      formData.append("bodyData", JSON.stringify(payload));

      const res = await updateEmployee(e._id, formData);
      if (payload.isEnabled) {
        ToastSuccess("Activated");
      } else {
        ToastError("Deactivated");
      }

      setData((prevData) =>
        prevData.map((item) =>
          item._id === e._id ? { ...item, isEnabled: payload.isEnabled } : item
        )
      );
    } catch (error) {
      ToastError(error?.data?.message);
    }
  };

  const debouncedHandleSearch = useCallback(
    debounce((searchText) => {
      setQueryParam((queryParams) => ({
        ...queryParams,
        search: searchText,
      }));
    }, 300),
    []
  );

  const handleSearch = (searchText) => {
    debouncedHandleSearch(searchText);
  };

  const columns = [
    { id: "employeeID", label: "Emp ID" },
    { id: "name", label: "Name" },
    { id: "email", label: "Email" },
    { id: "mobileNo", label: "Mobile No" },
  ];

  const tableConfig = {
    isMore: true,
    isAction: true,
    isView: true,
    isEdit: canEdit("manager"),
    isToggle: true,
    isDelete: canDelete("manager"),
    isAdmin: true,
  };
  return (
    <div className="mainPageRenderingContainer">
      <Box sx={{ height: "fit-content" }}>
        <Grid container spacing={2} sx={{ justifyContent: "space-between" }}>
          <Grid item xs={12} sm={2.5}>
            <Box className="SearchInputBoxContainer">
              <SearchOutlinedIcon className="Search_Icon" />
              <input
                className="SearchInputBox"
                placeholder="Search here"
                onChange={(e) => handleSearch(e.target.value)}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6.5} />
          <Grid item xs={6} sm={2}>
            <PermissionGate module="manager" action="add">
              <Button
                startIcon={<AddOutlinedIcon />}
                onClick={() => handleAdd()}
                className="Add-Button w-100"
              >
                Add Manager
              </Button>
            </PermissionGate>
          </Grid>
        </Grid>
      </Box>
      <MasterCommonTable
        tableConfig={tableConfig}
        data={data}
        columns={columns}
        handleView={handleView}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handleToggle={handleToggle}
        tableTotalCount={tableTotalCount}
      />
      <Dialog
        open={openDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="md"
      >
        {openDrawer ? (
          <AddUser
            selectedData={selectedData}
            setOpenDrawer={setOpenDrawer}
            formType={
              selectedData.isView ? "view" : selectedData._id ? "edit" : "add"
            }
            Ismanager={true}
            GetData={getData}
          />
        ) : null}
      </Dialog>
    </div>
  );
};

export default Manager;
